import { call, put, takeLatest } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import {
  currentUserSuccess,
  currentUserFailure,
  getAllUserSuccess,
  getAllUserFailure,
  getUserDetailsSuccess,
  getUserDetailsFailure,
  getAllClientRolesSuccess,
  getAllClientRolesFailure,
  getUserCertificationsFailure,
  getUserCertificationsSuccess,
  getBlackOutDatesFailure,
  getBlackOutDatesRequest,
  getBlackOutDatesSuccess,
} from "./slice";
import { USER_REQUEST } from "./types";
import { axiosInstance } from "../../utils/AxiosInstance";
import { userType } from "../../utils/Constant";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function* currentUser() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/users/current-user`
    );
    yield put(currentUserSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(currentUserFailure({ error: err.response?.data }));
  }
}

function* getAllUsers(action: any) {
  const params = {
    ...action.payload,
  };
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/users`,
      {
        params,
      }
    );
    yield put(getAllUserSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getAllUserFailure({ error: err.response?.data }));
  }
}

function* getUserDetails(action: any) {
  try {
    const { id } = action.payload;
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/users/${id}`
    );
    yield put(getUserDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getUserDetailsFailure({ error: err.response?.data }));
  }
}

function* getUserCertifications(action: any) {
  try {
    const { id } = action.payload;
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/users/${id}/certifications`
    );
    yield put(getUserCertificationsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getUserCertificationsFailure({ error: err.response?.data }));
  }
}

function* getAllClientRoles() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/roles`,
      {
        params: {
          type: userType.tenant,
        },
      }
    );
    yield put(getAllClientRolesSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getAllClientRolesFailure({ error: err.response?.data }));
  }
}

function* fetchBlackOutDates(
  action: ReturnType<typeof getBlackOutDatesRequest>
): Generator<any, void, any> {
  try {
    const response: AxiosResponse<any> = yield call(
      axiosInstance.get,
      `${API_BASE_URL}/api/v1/users/${action.payload.id}/blackout-days`,
      {
        params: {
          fromDate: action.payload.fromDate,
          toDate: action.payload.toDate,
        },
      }
    );
    if (response?.status === 200) {
      yield put(getBlackOutDatesSuccess(response.data));
    } else {
      yield put(
        getBlackOutDatesFailure(
          response?.data?.message || "Failed to fetch black out dates"
        )
      );
    }
  } catch (error: any) {
    yield put(
      getBlackOutDatesFailure(
        error?.response?.data?.message || "An error occurred"
      )
    );
  }
}

export function* userSaga() {
  yield takeLatest(`${USER_REQUEST}/currentUserRequest`, currentUser);
  yield takeLatest(`${USER_REQUEST}/getAllUserRequest`, getAllUsers);
  yield takeLatest(`${USER_REQUEST}/getUserDetailsRequest`, getUserDetails);
  yield takeLatest(
    `${USER_REQUEST}/getAllClientRolesRequest`,
    getAllClientRoles
  );
  yield takeLatest(
    `${USER_REQUEST}/getUserCertificationsRequest`,
    getUserCertifications
  );
  yield takeLatest(
    `${USER_REQUEST}/getBlackOutDatesRequest`,
    fetchBlackOutDates
  );
}
